import {
  Component, ChangeDetectionStrategy, ViewEncapsulation,
  OnInit, OnDestroy, ViewChild, ElementRef, AfterViewChecked, inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';
import { PanoDurumService } from '@uygulamalar/hmi-pano/services/pano-durum.service';
import { hmiAyarGetir } from '@uygulamalar/hmi-pano/config/hmi-parametre-setleri';

@Component({
  selector: 'hmi-pano-bosta',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './bosta.component.html',
  styleUrl: './bosta.component.less',
})
export class HmiPanoBostaComponent extends FikoYTKokBilesenComponent implements OnInit, OnDestroy, AfterViewChecked {
  constructor() { super(); }
  durum = inject(PanoDurumService);

  @ViewChild('idleVideo') idleVideoRef: ElementRef<HTMLVideoElement>;

  // ─── Slide rotation ────────────────────────────────────────────────────
  private _aktifSlide = 0;
  get aktifSlide() { return this._aktifSlide; }
  set aktifSlide(v: number) { this._aktifSlide = v; this.slideAnimasyonBaslat(v); }
  readonly slideAdet = 5;
  private _slideTimer: any;

  // ─── Swipe ─────────────────────────────────────────────────────────────
  private _swipeStartX = 0;
  swipeBasla(e: TouchEvent) { this._swipeStartX = e.touches[0].clientX; }
  swipeBitir(e: TouchEvent) {
    const dx = e.changedTouches[0].clientX - this._swipeStartX;
    if (Math.abs(dx) > 50) dx < 0 ? this.slideSonraki() : this.slideOnceki();
  }
  swipeMouseBasla(e: MouseEvent) { this._swipeStartX = e.clientX; }
  swipeMouseBitir(e: MouseEvent) {
    const dx = e.clientX - this._swipeStartX;
    if (Math.abs(dx) > 50) dx < 0 ? this.slideSonraki() : this.slideOnceki();
  }

  slideGit(index: number) { this.aktifSlide = index; this.startSlideRotation(); this.CD.markForCheck(); }
  slideSonraki() { this.slideGit((this.aktifSlide + 1) % this.slideAdet); }
  slideOnceki() { this.slideGit((this.aktifSlide - 1 + this.slideAdet) % this.slideAdet); }

  private startSlideRotation() {
    this.stopSlideRotation();
    const slideAraligi = hmiAyarGetir<number>('slideAraligi', 6) * 1000;
    this._slideTimer = setInterval(() => {
      this.aktifSlide = (this.aktifSlide + 1) % this.slideAdet;
      this.CD.markForCheck();
    }, slideAraligi);
  }

  private stopSlideRotation() {
    if (this._slideTimer) { clearInterval(this._slideTimer); this._slideTimer = null; }
  }

  // ─── Animasyonlar ──────────────────────────────────────────────────────
  animasyonSayac: { [key: string]: number } = {};
  animKazasizGun = 0;
  animGaugeYuzde = 0;
  animTezgahCalisanSayi = 0;
  animTezgahBostaSayi = 0;
  animTezgahBakimSayi = 0;
  private _animTimers: any[] = [];

  kazasizGun = 142;

  istatistikler = [
    { baslik: 'Günlük Adet', deger: 70, alt: 'Ortalama Üretilen Parça Sayısı' },
    { baslik: 'Haftalık Adet', deger: 700, alt: 'Ortalama Üretilen Parça Sayısı' },
    { baslik: 'Aylık Adet', deger: 5400, alt: 'Ortalama Üretilen Parça Sayısı' },
    { baslik: 'Toplam Adet', deger: 42850, alt: 'Tüm Zamanlar' },
  ];

  tezgahlar = [
    { ad: 'CNC-001', durum: 'calisiyor', operasyon: 'Freze', yuzde: 78 },
    { ad: 'CNC-002', durum: 'calisiyor', operasyon: 'Tornalama', yuzde: 92 },
    { ad: 'CNC-003', durum: 'bosta', operasyon: '-', yuzde: 0 },
    { ad: 'TORNA-001', durum: 'calisiyor', operasyon: 'İşleme', yuzde: 65 },
    { ad: 'KALIP-001', durum: 'bakim', operasyon: 'Bakım', yuzde: 0 },
    { ad: 'CNC-004', durum: 'calisiyor', operasyon: 'Delme', yuzde: 45 },
  ];

  private slideAnimasyonBaslat(slide: number) {
    this.animasyonlariDurdur();
    switch (slide) {
      case 0: break;
      case 1:
        this.animKazasizGun = 0;
        this.animasyonluSay(v => this.animKazasizGun = v, this.kazasizGun, 1500);
        break;
      case 2:
        this.istatistikler.forEach((stat, i) => {
          this.animasyonSayac[i] = 0;
          this.animasyonluSay(v => this.animasyonSayac[i] = v, stat.deger, 1200 + i * 200);
        });
        this.animGaugeYuzde = 0;
        this.animasyonluSay(v => this.animGaugeYuzde = v, 75, 1800);
        break;
      case 4: {
        this.animTezgahCalisanSayi = 0;
        this.animTezgahBostaSayi = 0;
        this.animTezgahBakimSayi = 0;
        const calisan = this.tezgahlar.filter(t => t.durum === 'calisiyor').length;
        const bosta = this.tezgahlar.filter(t => t.durum === 'bosta').length;
        const bakim = this.tezgahlar.filter(t => t.durum === 'bakim').length;
        this.animasyonluSay(v => this.animTezgahCalisanSayi = v, calisan, 800);
        this.animasyonluSay(v => this.animTezgahBostaSayi = v, bosta, 800);
        this.animasyonluSay(v => this.animTezgahBakimSayi = v, bakim, 800);
        break;
      }
    }
  }

  private animasyonluSay(setter: (v: number) => void, target: number, duration: number) {
    if (target === 0) { setter(0); return; }
    const adimSayisi = Math.min(Math.ceil(duration / 50), 30);
    const adimSure = duration / adimSayisi;
    for (let i = 1; i <= adimSayisi; i++) {
      const timer = setTimeout(() => {
        const progress = i / adimSayisi;
        const eased = 1 - Math.pow(1 - progress, 3);
        setter(Math.round(target * eased));
        this.CD.detectChanges();
      }, adimSure * i);
      this._animTimers.push(timer);
    }
  }

  private animasyonlariDurdur() {
    for (const t of this._animTimers) clearTimeout(t);
    this._animTimers = [];
  }

  tezgahDurumRenk(durum: string): string {
    switch (durum) {
      case 'calisiyor': return 'var(--green)';
      case 'bosta': return 'var(--yellow)';
      case 'bakim': return 'var(--red)';
      default: return 'var(--text-3)';
    }
  }

  tezgahDurumYazi(durum: string): string {
    switch (durum) {
      case 'calisiyor': return 'Aktif';
      case 'bosta': return 'Boşta';
      case 'bakim': return 'Bakımda';
      default: return '-';
    }
  }

  // ─── Lifecycle ─────────────────────────────────────────────────────────
  ngOnInit() {
    this.istatistikler.forEach((_, i) => { this.animasyonSayac[i] = 0; });
    this.slideAnimasyonBaslat(0);
    this.startSlideRotation();
  }

  ngAfterViewChecked() {
    const v = this.idleVideoRef?.nativeElement;
    if (v && v.paused && !v.dataset['started']) {
      v.muted = true;
      v.play().catch(() => {});
      v.dataset['started'] = '1';
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.stopSlideRotation();
    this.animasyonlariDurdur();
  }
}
